"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentCreateInvoiceButton = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = require("../../../../Button");
require("./index.scss");
const className = 'allotment-create-invoice-button';
const AllotmentCreateInvoiceButton = (props) => {
    const { onClick, disabled, hidden } = props;
    const buttonProps = {
        icon: 'plus',
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/CreateInvoiceButton:label', defaultMessage: 'Create invoice' })),
        onClick,
        disabled,
        hidden,
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Button_1.Button, { ...buttonProps })));
};
exports.AllotmentCreateInvoiceButton = AllotmentCreateInvoiceButton;
//# sourceMappingURL=index.js.map